module.exports = __webpack_public_path__ + "static/media/temp-persona-7.473c4a28.jpg";